import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { OrderCodeTextInputComponent } from '../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { KYMW1510Model } from './kymw1510.model';
import { KYMW1510InputModel } from './vo/kymw1510-input.model';
import { UpdateCwsIconFilePeriodVo } from './vo/update-cws-icon-file-period.model';
import { GetMarkGroupListService } from '../kymw1500/api-services/get-mark-group-list.service';
import { GetCwsIconBaseData } from './api-services/get-cws-icon-base-data-service';
import { UpdateCwsIconFilePeriod } from './api-services/update-cws-icon-file-period-service';
import { GetCodeListService } from '../../../commons/kymw02/api-services/get-code-list.service';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';

/**
 * アイコンファイル適用期間指定画面を管理するクラス
 *
 * @export KYMW1510Component
 * @class KYMW1510Component
 */
@Component({
  selector: 'app-kymw1510',
  templateUrl: 'kymw1510.component.html',
  styleUrls: ['kymw1510.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1510Component extends PlessViewHelperSub implements OnInit {
  @ViewChild('txt_IconCode', { static: true }) txt_IconCode: ElementRef;
  @ViewChild('txt_StartOrderCode', { static: true }) txt_StartOrderCode: OrderCodeTextInputComponent;
  @ViewChild('txt_EndOrderCode', { static: true }) txt_EndOrderCode: OrderCodeTextInputComponent;

  kymw1510Model: KYMW1510Model = new KYMW1510Model();

  /**
   *Creates an instance of KYMW1510Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1510Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private getMarkGroupListService: GetMarkGroupListService,
    private getCwsIconBaseData: GetCwsIconBaseData,
    private updateCwsIconFilePeriod: UpdateCwsIconFilePeriod,
    private getCodeListService: GetCodeListService,
    private elementRef: ElementRef,
    ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1510Component
   */
  public ngOnInit() {
    this.componentName = 'KYMW1510';

    // マークグループ一覧取得
    this.getMarkGroupListService.execute((data: any) => {
      if (PlessViewUtilsSub.isEmptyArray(data)) {
        // マークグループコードが取得できませんでした
        this.dialogService.openAlertGetMessage('E0127', [], () => {
          this.closeFunction();
        });
      }
      this.kymw1510Model.updateMarkGroupList(data);

      // コード区分情報取得
      this.getCodeListService.execute(
        'ctp051',
        '',
        this.kymw1510Model,
        'arrangeDivList',
        () => {
          // アイコン区分情報取得
          this.getCodeListService.execute(
            'ctp050',
            '',
            this.kymw1510Model,
            'iconDivList',
            () => {
              // CWSアイコン基本情報取得
              this.getCwsIconBaseData.execute({
                iconCode: this.kymw1510Model.iconCode,
                iconCodeBranch: this.kymw1510Model.iconCodeBranch
              }, (data: any) => {
                if (data === null || data === undefined || Object.keys(data).length === 0) {
                  // アイコン情報は存在しません
                  this.dialogService.openAlertGetMessage('E0122', ['アイコン情報'], () => {
                    this.closeFunction();
                  });
                }
                this.kymw1510Model.updateCwsIconBaseData(data);
                setTimeout(() => {
                  // 使用終了受注コードにフォーカスがいくため遅延評価
                  this.txt_IconCode.nativeElement.focus();
                }, 100)
              });
            }
          )
        }
      )
    });
  }

  /**
   * 画面初期値設定
   *
   * @param vo
   * @memberof KYMW1510Component
   */
  public setInterfaceParam(vo: KYMW1510InputModel) {
    this.kymw1510Model.iconCode = vo.iconCode;
    this.kymw1510Model.iconCodeBranch = vo.iconCodeBranch;
  }

  /**
   * 指定なし（開始） チェックボックス 値変更
   *
   * @memberof KYMW1510Component
   */
  public eventNotDesignateStart_CLICKHandler() {
    if (this.kymw1510Model.notDesignateStart) {
      this.kymw1510Model.startOrderCode = '';
      this.kymw1510Model.startOrderCodeEnabled = false;
    } else {
      this.kymw1510Model.startOrderCodeEnabled = true;
    }
  }

  /**
   * 指定なし（終了） チェックボックス 値変更
   *
   * @memberof KYMW1510Component
   */
  public eventNotDesignateEnd_CLICKHandler() {
    if (this.kymw1510Model.notDesignateEnd) {
      this.kymw1510Model.endOrderCode = '';
      this.kymw1510Model.endOrderCodeEnabled = false;
    } else {
      this.kymw1510Model.endOrderCodeEnabled = true;
    }
  }

  /**
   * 設定 ボタン 押下
   *
   * @memberof KYMW1510Component
   */
  public eventSetting_CLICKHandler() {
    if (!this.kymw1510Model.notDesignateStart && this.kymw1510Model.startOrderCode === '') {
      this.dialogService.openAlertGetMessage('E0110', ['使用開始受注コード']);
      return;
    }
    if (!this.kymw1510Model.notDesignateEnd && this.kymw1510Model.endOrderCode === '') {
      this.dialogService.openAlertGetMessage('E0110', ['使用終了受注コード']);
      return;
    }
    if (!this.kymw1510Model.notDesignateStart && !this.txt_StartOrderCode.isValidOrderCode()) {
      this.dialogService.openAlertGetMessage('E0122', ['使用開始受注コード']);
      return;
    }
    if (!this.kymw1510Model.notDesignateEnd && !this.txt_EndOrderCode.isValidOrderCode()) {
      this.dialogService.openAlertGetMessage('E0122', ['使用終了受注コード']);
      return;
    }
    if (!this.kymw1510Model.notDesignateStart && !this.kymw1510Model.notDesignateEnd) {
      if (Number(this.kymw1510Model.startOrderCode) > Number(this.kymw1510Model.endOrderCode)) {
        this.dialogService.openAlertGetMessage('E0123', ['受注コード']);
        return;
      }
    }

    this.updateCwsIconFilePeriod.execute(new UpdateCwsIconFilePeriodVo(
      this.kymw1510Model.iconCode,
      this.kymw1510Model.iconCodeBranch,
      this.kymw1510Model.startOrderCode,
      this.kymw1510Model.endOrderCode
    ), () => {
      this.closeFunction();
    });
  }
}
